/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCardChallengeRequestCard
 */
export interface GetCardChallengeRequestCard {
    /**
     * 
     * @type {string}
     * @memberof GetCardChallengeRequestCard
     */
    encryptedCardNumber: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardChallengeRequestCard
     */
    encryptedExpiryMonth: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardChallengeRequestCard
     */
    encryptedExpiryYear: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardChallengeRequestCard
     */
    encryptedSecurityCode: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardChallengeRequestCard
     */
    holderName: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardChallengeRequestCard
     */
    type: string;
}

/**
 * Check if a given object implements the GetCardChallengeRequestCard interface.
 */
export function instanceOfGetCardChallengeRequestCard(value: object): value is GetCardChallengeRequestCard {
    if (!('encryptedCardNumber' in value) || value['encryptedCardNumber'] === undefined) return false;
    if (!('encryptedExpiryMonth' in value) || value['encryptedExpiryMonth'] === undefined) return false;
    if (!('encryptedExpiryYear' in value) || value['encryptedExpiryYear'] === undefined) return false;
    if (!('encryptedSecurityCode' in value) || value['encryptedSecurityCode'] === undefined) return false;
    if (!('holderName' in value) || value['holderName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GetCardChallengeRequestCardFromJSON(json: any): GetCardChallengeRequestCard {
    return GetCardChallengeRequestCardFromJSONTyped(json, false);
}

export function GetCardChallengeRequestCardFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCardChallengeRequestCard {
    if (json == null) {
        return json;
    }
    return {
        
        'encryptedCardNumber': json['encryptedCardNumber'],
        'encryptedExpiryMonth': json['encryptedExpiryMonth'],
        'encryptedExpiryYear': json['encryptedExpiryYear'],
        'encryptedSecurityCode': json['encryptedSecurityCode'],
        'holderName': json['holderName'],
        'type': json['type'],
    };
}

export function GetCardChallengeRequestCardToJSON(json: any): GetCardChallengeRequestCard {
    return GetCardChallengeRequestCardToJSONTyped(json, false);
}

export function GetCardChallengeRequestCardToJSONTyped(value?: GetCardChallengeRequestCard | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'encryptedCardNumber': value['encryptedCardNumber'],
        'encryptedExpiryMonth': value['encryptedExpiryMonth'],
        'encryptedExpiryYear': value['encryptedExpiryYear'],
        'encryptedSecurityCode': value['encryptedSecurityCode'],
        'holderName': value['holderName'],
        'type': value['type'],
    };
}

